import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { BookingsExtendsComponent } from 'src/app/booking/bookings/bookings-extends/bookings-extends.component';
import { TransfersExtendsComponent } from 'src/app/booking/transfers/transfers-extends/transfers-extends.component';
import { ToolsService } from 'src/app/utils/tools.service';

@Component({
  selector: 'app-schedule-detail',
  templateUrl: './schedule-detail.component.html',
  styleUrls: ['./schedule-detail.component.css']
})
export class ScheduleDetailComponent {
  @ViewChild(BookingsExtendsComponent) BookingsExtendsComponent: any;
  @ViewChild(TransfersExtendsComponent) TransfersExtendsComponent: any;

  @Output() onTransferEvent = new EventEmitter<string>();

  date_range: any = null;
  workinggroup_id: any = null;
  workinggroup_data: any = null;
  tour: any = null;
  bookings: any = [];

  constructor(
    private bookingService: BookingsService,
    public toolsService: ToolsService
  ) {}

  init(param: any) {
    this.date_range = param.date_range;
    this.workinggroup_id = param.workinggroup_id;
    this.workinggroup_data = param.workinggroup_data;
    this.tour = param.tour;

    let val_params =
      'date_departure=' +
      this.date_range +
      '&tour_id=' +
      this.tour.id +
      '&workinggroup_id=' +
      this.workinggroup_id;
    this.bookingService.toursPending(val_params).subscribe({
      next: (data: any) => {
        this.bookings = data.results;
      }
    });
  }

  extendsTransfers(book: any, item: any) {
    item.id = book.id_toursbookings;
    item.detail_id = book.id_toursbookings;
    item.description = this.tour.description;
    // contruir objetos
    let book_: any = {
      id: book.id_bookings
    };
    this.TransfersExtendsComponent.init(book_, item);
  }

  afterTransfer(data: any) {
    this.init(this.getDataParams());
    this.onTransferEvent.emit(data);
  }

  detailBookingExtends(booking: any) {
    this.BookingsExtendsComponent.init(booking.booking_id);
  }

  afterBookingDetail(data: any) {
    // let params: any = {};
    // params.date_range = this.date_range;
    // params.tour = this.tour;
    // params.workinggroup_id = this.workinggroup_id;
    // params.workinggroup_data = this.workinggroup_data;
    this.init(this.getDataParams());
  }

  getDataParams() {
    let params: any = {};
    params.date_range = this.date_range;
    params.tour = this.tour;
    params.workinggroup_id = this.workinggroup_id;
    params.workinggroup_data = this.workinggroup_data;
    return params;
  }

  close() {
    setTimeout(() => {
      this.tour = null;
      this.bookings = [];
    }, 250);
  }
}
